<template>
  <div
    id="user-actions"
    class="no-shrink">
    <!-- <button @click="emit">open</button> -->
    <span
      id="contact-info"
      class="user-action info"
      :class="{active: activeSection === 'info'}"
      @click="activateSection('info')"/>
    <span
      id="contact-notes"
      class="user-action notes"
      :class="{active: activeSection === 'notes'}"
      @click="activateSection('notes')"/>
    <span
      v-if="hasProperty"
      id="property-details"
      class="user-action house"
      :class="{active: activeSection === 'properties'}"
      @click="activateSection('properties')"/>

    <!-- POPOVERS for action buttons -->
    <b-popover
      ref="contactInfoPopoverRef"
      target="contact-info"
      triggers="hover"
      placement="left"
      custom-class="basic-popover left-3">
      Contact info
    </b-popover>
    <b-popover
      ref="contactNotesPopoverRef"
      target="contact-notes"
      triggers="hover"
      placement="left"
      custom-class="basic-popover left-3">
      Contact notes
    </b-popover>
    <b-popover
      v-if="hasProperty"
      ref="propertyDetailsPopoverRef"
      target="property-details"
      triggers="hover"
      placement="left"
      custom-class="basic-popover">
      Property details
    </b-popover>
  </div>
</template>

<style lang="scss" scoped>
#user-actions {
  overflow: hidden;
  background-color: $white;
  width: 50px;
  box-shadow: -1px 0 $greyBorderSecondary;
  z-index: 1000;

  .user-action {
    display: block;
    width: 26px;
    height: 26px;
    background-color: $blackPrimary;
    border-radius: 50%;
    margin: 13px 12px 0 12px;
    position: relative;
    cursor: pointer;

    &::before {
      filter: invert(100%);
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &.info {
      &::before {
        filter: invert(0%);
        background-image: url('~@/assets/img/SB-Icons/member.svg');
        background-size: 10px;
        background-position: center center;
      }
    }

    &.notes {
      &::before {
        filter: invert(100%);
        background-image: url('~@/assets/img/SB-Icons/notes.svg');
        background-size: 10px;
        background-position: center center;
      }
    }

    &.house {
      &::before {
        background-image: url('~@/assets/img/icons/house.svg');
        background-size: 50%;
      }
    }

    &:hover {
      box-shadow: 0px 0px 0 5px $actionButtonHoverGray;
    }

    &.active {
      background-color: $bluePrimary;
      box-shadow: 0px 0px 0 5px $actionButtonHoverBlue;
    }
  }
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';

import ChatEventBus from '../ChatEventBus';

export default {
  name: 'UserActions',
  components: {},
  data() {
    return {
      activeSection: null,
      notesPropertiesRegex: new RegExp('Received e-mail', 'g'),
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      contact: 'contact/contact',
      activeDetailsSection: 'contactDetails/activeDetailsSection',
    }),
    // on contact change there should be a check if the user has property or not so the icon can be shown or hidden
    hasProperty() {
      // return this.contact.meta_data.notes.some(note => note.match(this.notesPropertiesRegex));
      return false;
    },
    organisationId() {
      return this.$route.params.organisationId;
    },
  },
  watch: {
    activeConversation(newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        // We decided not to preload this on every conversation change
        // this.getData();
      }
    },
    contact(changedContact) {
      // on contact change there should be a check if the user has property or not so the icon can be shown or hidden
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.activeDetailsSection) {
        this.activeSection = this.activeDetailsSection;
      }
    });
    this.getData();

    if (localStorage.getItem('contactDetailsView')) {
      this.forceSection(localStorage.getItem('contactDetailsView'));
    }

    ChatEventBus.$on('showUserDetails', (section) => {
      if (section === 'null') {
        section = null;
      }
      this.activeSection = section;
    });
  },
  methods: {
    ...mapActions({
      fetchContact: 'contact/fetchContact',
      fetchContactData: 'contactDetails/contactDataFetch',
      activateSectionVuex: 'contactDetails/activateSection',
    }),
    // emit() {
    //     ChatEventBus.$emit('showUserDetails', '');
    // },
    // TODO on rewrite skip this part and do it via vuex as it is partially done now
    activateSection(section) {
      if (this.activeSection !== section) {
        this.activeSection = section;
        this.activateSectionVuex(section);
      } else {
        this.activeSection = null;
        this.activateSectionVuex(null);
      }
      ChatEventBus.$emit('showUserDetails', this.activeSection);
      localStorage.setItem('contactDetailsView', this.activeSection);

      this.$refs.contactInfoPopoverRef.$emit('close');
      this.$refs.contactNotesPopoverRef.$emit('close');
      if (this.$refs.propertyDetailsPopoverRef) {
        this.$refs.propertyDetailsPopoverRef.$emit('close');
      }
    },
    forceSection(section) {
      this.activateSectionVuex(section);
      ChatEventBus.$emit('showUserDetails', section);
    },
    getTooltipConfig(text) {
      return {
        title: text,
        placement: 'left',
        animation: false,
        delay: { show: 500, hide: 200 },
      };
    },
    getData() {
      if (!(this.$route.params.conversationId && this.$route.params.conversationId.startsWith('TEMP-conversation')) || !this.$lodash.isEmpty(this.activeConversation)) {
        if (this.activeConversation.contact && !this.activeConversation.contact.details_loaded && this.activeConversation.contact.id) {
          // this.fetchContact({
          //   // merchant_id: this.$route.params.merchant_id, // load from conversation, not route
          //   merchant_id: this.activeConversation.business_id,
          //   contact_id: this.activeConversation.contact.id,
          // });
          // NOTE: The one above is deprecated but lot of dependencies is stil on it. That's why we have both active for now. Waiting for a rewrite.
          this.fetchContactData({
            organisation_id: this.organisationId,
            business_id: this.activeConversation.business_id,
            contact_id: this.activeConversation.contact.id,
          });
        } else {
          // this.contact = this.activeConversation.contact;
        }
      } else {
        this.activateSection(null);
      }
    },
  },
};
</script>
